import types from './types'

// Call this to bump the data load
export const requestData = (key, revertEdits) => ({ type: types.PIVOT_TABLE_REQUEST_DATA, key, revertEdits })
export const setFetching = (key, fetching) => ({ type: types.PIVOT_TABLE_SET_FETCHING, key, fetching })

export const setVisibleColumns = (key, visibleColumns) => ({ type: types.PIVOT_TABLE_SET_VISIBLE_COLUMNS, key, visibleColumns })
export const setColumnSizes = (key, columnSizes) => ({ type: types.PIVOT_TABLE_SET_COLUMN_SIZES, key, columnSizes })
export const setGroups = (key, groups) => ({ type: types.PIVOT_TABLE_SET_GROUPS, key, groups })
export const sort = (key, sortColumn, sortDirection) => ({ type: types.PIVOT_TABLE_SORT, key, sortColumn, sortDirection })
export const search = (key, search) => ({ type: types.PIVOT_TABLE_SEARCH, key, search })
export const updateFilters = (key, filters) => ({ type: types.PIVOT_TABLE_UPDATE_FILTERS, key, filters })
export const clearSearch = (key, onlyReloadIfVisible = false) => ({ type: types.PIVOT_TABLE_SEARCH, key, search: '', onlyReloadIfVisible })
export const page = (key, page) => ({ type: types.PIVOT_TABLE_PAGE, key, page })
export const updatePageSize = (key, pageSize, page = null) => ({ type: types.PIVOT_TABLE_PAGE_SIZE_UPDATE, key, pageSize, page })
export const addEntity = (key, entity, otherData) => ({ type: types.PIVOT_TABLE_ADD_ENTITY, key, entity, ...otherData })
export const addEntityAtIndex = (key, entity, index, otherData) => ({ type: types.PIVOT_TABLE_ADD_ENTITY_AT_INDEX, key, entity, index, ...otherData })
export const editEntity = (key, entity, index = null, otherData = null) => ({ type: types.PIVOT_TABLE_EDIT_ENTITY, key, entity, index, ...otherData })
export const deleteEntity = (key, entity, index) => ({ type: types.PIVOT_TABLE_DELETE_ENTITY, key, entity, index })
export const setEntities = (key, entities, otherData) => ({ type: types.PIVOT_TABLE_SET_ENTITIES, key, entities, ...otherData })
export const copyEntity = (key, entity) => ({ type: types.PIVOT_TABLE_COPY_ENTITY, key, entity })
export const toggleSelectedEntity = (key, entity, index) => ({ type: types.PIVOT_TABLE_TOGGLE_SELECTED_ENTITY, key, entity, index })
export const canSelectRows = (key) => ({ type: types.PIVOT_TABLE_CAN_SELECT_ROWS, key })
export const cannotSelectRows = (key) => ({ type: types.PIVOT_TABLE_CANNOT_SELECT_ROWS, key })
export const selectAllRows = (key) => ({ type: types.PIVOT_TABLE_SELECT_ALL_ROWS, key })
export const deSelectAllRows = (key) => ({ type: types.PIVOT_TABLE_DESELECT_ALL_ROWS, key })
export const changeSelectedRows = (key, selectedIds) => ({ type: types.PIVOT_TABLE_CHANGE_SELECTED_ROWS, key, selectedIds})
export const toggleCollapsedItems = (key) => ({ type: types.PIVOT_TABLE_TOGGLE_COLLAPSED_ITEMS, key })
export const reorderEntity = (key, entity, fromIndex, toIndex) => ({ type: types.PIVOT_TABLE_REORDER_ENTITY, key, entity, fromIndex, toIndex })
export const setGridStretch = (key, gridStretch) => ({ type: types.PIVOT_TABLE_SET_GRID_STRETCH, key, gridStretch })
export const updatePivotTableParams = (key, params) => ({ type: types.PIVOT_TABLE_UPDATE_PARAMS, key, params })

export const reset = (key) => ({ type: types.PIVOT_TABLE_RESET, key })
export const resetPage = (key) => ({ type: types.PIVOT_TABLE_RESET_PAGE, key })
export const resetLoaded = (key) => ({ type: types.PIVOT_TABLE_RESET_LOADED, key })

export const loadData = (key) => ({ type: types.PIVOT_TABLE_LOAD_ATTEMPT, key })
export const loadDataSuccess = (key, data, count, revertEdits, response) => ({ type: types.PIVOT_TABLE_LOAD_SUCCESS, key, data, count, revertEdits, response })
export const loadDataFailure = (key, error, code) => ({ type: types.PIVOT_TABLE_LOAD_FAILURE, key, error, code })

export const editData = (key, entityKey, entity, save, recalcTotals) => ({ type: types.PIVOT_TABLE_EDIT_DATA, key, entityKey, entity, save, recalcTotals })
export const editDataMulti = (key, entities, save, otherData) => ({ type: types.PIVOT_TABLE_EDIT_DATA_MULTI, key, entities, save, ...otherData })

export const saveData = (key) => ({ type: types.PIVOT_TABLE_SAVE_ATTEMPT, key })
export const saveDataSuccess = (key, data) => ({ type: types.PIVOT_TABLE_SAVE_SUCCESS, key, data })
export const saveDataFailure = (key, error, code) => ({ type: types.PIVOT_TABLE_SAVE_FAILURE, key, error, code })
export const updateData = (key, data) => ({ type: types.PIVOT_TABLE_UPDATE_DATA, key, data})

export const exportData = (key, columns, fileName, params) => ({ type: types.PIVOT_TABLE_EXPORT, key, columns, fileName, params })
export const exportDataStart = (key) => ({ type: types.PIVOT_TABLE_EXPORT_START, key })
export const exportDataProgress = (key, rowsTotal, rowsDone) => ({ type: types.PIVOT_TABLE_EXPORT_PROGRESS, key, rowsTotal, rowsDone })
export const exportDataFinish = (key, success, message) => ({ type: types.PIVOT_TABLE_EXPORT_FINISH, key, success, message })

export const setVisibility = (key, visible) => ({ type: types.PIVOT_TABLE_SET_VISIBILITY, key, visible })

export default {
  requestData,
  setFetching,
  setVisibleColumns,
  setColumnSizes,
  setGroups,
  sort,
  search,
  clearSearch,
  page,
  addEntity,
  addEntityAtIndex,
  editEntity,
  deleteEntity,
  setEntities,
  copyEntity,
  toggleSelectedEntity,
  canSelectRows,
  cannotSelectRows,
  selectAllRows,
  deSelectAllRows,
  toggleCollapsedItems,
  reorderEntity,
  setGridStretch,
  reset,
  loadData,
  loadDataSuccess,
  loadDataFailure,
  editData,
  editDataMulti,
  saveData,
  saveDataSuccess,
  saveDataFailure,
  updateData,
  exportData,
  exportDataStart,
  exportDataProgress,
  exportDataFinish,
  setVisibility,
}
